import { z } from 'zod';

import { zodSuccessResponseSchema } from '../validations';

export const zodBulkBillDlnsPayloadSchema = z.object({
  assetIds: z.array(z.string().uuid()),
});

export const zodBulkBillDlnsEndpointSchema = z.tuple([
  z.literal('delivery_note'),
  z.literal('bulk'),
  z.literal('bill'),
]);

export { zodSuccessResponseSchema };
